// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"c63ee3a7","185":"c92764bd","373":"0612c56a","388":"ef21bb4a","454":"aad2edcc","465":"d6323268","480":"32c5f193","481":"e0002239","631":"a06526d6","675":"322a1f4e","757":"6cc1a70a","911":"1a608561"}[chunkId] + ".chunk.js";
};